import React, { Fragment } from 'react';
import { defaultTemplate, withAuth } from 'core/hoc';
import { PropTypes } from 'prop-types';

const iconName = name => (name ? '' + name : '');

const BaasicButtonTemplate = function({ onClick, authorization, ...otherProps }) {
	return <AuthContent authorization={authorization} onAction={onClick} {...otherProps} />;
};

BaasicButtonTemplate.propTypes = {
	onClick: PropTypes.func,
	authorization: PropTypes.any,
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	onAction: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
	doubleClick: PropTypes.bool,
};

const AuthContent = withAuth(DefaultContent);

function SingleClickButton({
	onlyIcon = false,
	disabled = false,
	content = null,
	type = 'button',
	iconAfter = true,
	className,
	onAction,
	title,
	label,
	icon,
	t,
	setRef,
}) {
	return onAction ? (
		<button
			ref={button => setRef(button)}
			type={type}
			disabled={disabled}
			onClick={onAction}
			className={className}
			title={t(title) || t(label)}
		>
			{content || IconAndLabel(iconAfter, onlyIcon, icon, label, t)}
		</button>
	) : null;
}

function IconAndLabel(iconAfter, onlyIcon, icon, label, t) {
	return iconAfter ? (
		<Fragment>
			<span className={`${iconName(icon)}`} />
			{!onlyIcon && t(label)}
		</Fragment>
	) : (
		<Fragment>
			{!onlyIcon && t(label)}
			<span className={`${iconName(icon)}`} />
		</Fragment>
	);
}

SingleClickButton.propTypes = {
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	onAction: PropTypes.func,
	setRef: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
	iconAfter: PropTypes.bool,
};

function DoubleClickButton({
	onlyIcon = false,
	disabled = false,
	content = null,
	type = 'button',
	iconAfter = true,
	className,
	title,
	onAction,
	label,
	icon,
	t,
	setRef,
}) {
	return onAction ? (
		<button
			ref={button => setRef(button)}
			type={type}
			disabled={disabled}
			onDoubleClick={onAction}
			className={className}
			title={t(title) || t(label)}
		>
			{content || IconAndLabel(iconAfter, onlyIcon, icon, label, t)}
		</button>
	) : null;
}

DoubleClickButton.propTypes = {
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	setRef: PropTypes.func,
	onAction: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
	iconAfter: PropTypes.bool,
};

function DefaultContent({
	onlyIcon = false,
	disabled = false,
	content = null,
	type = 'button',
	iconAfter = true,
	className,
	onAction,
	label,
	title,
	icon,
	t,
	doubleClick = false,
	setRef = () => {},
}) {
	return doubleClick ? (
		<DoubleClickButton
			onlyIcon={onlyIcon}
			disabled={disabled}
			content={content}
			type={type}
			className={className}
			onAction={onAction}
			label={label}
			icon={icon}
			title={title || label}
			t={t}
			setRef={setRef}
			iconAfter={iconAfter}
		/>
	) : (
		<SingleClickButton
			onlyIcon={onlyIcon}
			disabled={disabled}
			content={content}
			type={type}
			className={className}
			onAction={onAction}
			label={label}
			title={title || label}
			icon={icon}
			t={t}
			setRef={setRef}
			iconAfter={iconAfter}
		/>
	);
}

DefaultContent.propTypes = {
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	onAction: PropTypes.func,
	setRef: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
	doubleClick: PropTypes.bool,
};

export default defaultTemplate(BaasicButtonTemplate);
